export const KALENDER_GET = 'KALENDER_GET';